import React from "react";
import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import NiceScrollBox from "../Shared/NiceScrollBox";
import VendorMenu from "./vendorMenu";
import { vendorMainColumnMaxWidthSx } from "../../config/vendorContentMaxWidth";

function VendorLayout() {
  const location = useLocation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        height: "100vh",
        overflow: "hidden",
        width: "100%",
        backgroundColor: "#f5f5f5",
      }}
    >
      <VendorMenu activeRoute={location.pathname} />
      <NiceScrollBox
        component="main"
        variant="panel"
        sx={{
          flex: 1,
          width: { xs: "100%", md: 0 },
          maxWidth: "100%",
        }}
      >
        <Box
          sx={{
            p: 4,
            pt: { xs: 10, md: 4 },
            ...vendorMainColumnMaxWidthSx,
          }}
        >
          <Outlet />
        </Box>
      </NiceScrollBox>
    </Box>
  );
}

export default VendorLayout;
